
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

import InfoBlock from './components/InfoBlock.vue'
import CommentBlock from './components/CommentBlock.vue'

@Component({
  components: {
    InfoBlock,
    CommentBlock,
  },
})
export default class Member extends Vue {
  breadcrumbItems = [
    { label: '首頁', to: '/' },
    { label: '最新功能' },
    { label: '優惠功能' }
  ]
  get isH5() {
    return AppModule.isH5
  }

  get images() {
    return [
      'https://spics.inctrip.com/15ededb9b3806a68611a87cbbf77c818.png',
      'https://spics.inctrip.com/b53a935a3f900200e286a5a15c4c726a.png',
      'https://spics.inctrip.com/8732c047da54fc4aed103cc10fb333a8.png',
      'https://spics.inctrip.com/2ded467173f900e344b9091c7187bc3e.png'
    ]
  }
}
